// Applies a theme colour immediately (no page reload) and tells anything that
// cached the colour in JS — e.g. Google Maps overlays — to refresh it.
export const THEME_CHANGED_EVENT = "hcm-theme-changed";

export function applyThemeColors(primary, secondary) {
  try {
    localStorage.setItem("primary-color", primary);
    localStorage.setItem("secondary-color", secondary);
  } catch (e) {
    // storage unavailable (private mode) — the colour still applies for this session
  }
  const rootStyle = document.documentElement.style;
  rootStyle.setProperty("--primary-color", primary);
  rootStyle.setProperty("--secondary-color", secondary);
  window.dispatchEvent(
    new CustomEvent(THEME_CHANGED_EVENT, { detail: { primary, secondary } })
  );
}
